import request from '@/api/config/request'

const prex = "api/financeiro/pagamento";

export function registerPagamento(data) {
    return request({
        url: `${prex}`,
        method: 'post',
        data
    })
}

export function verificaPagamentoDUAM(duam) {
    return request({
        url: `${prex}/${duam}`,
        method: 'get'
    })
}

export function verificaAlteracaoVencimento(duam,vencimento) {
    return request({
        url: `${prex}/altera_vencimento/${duam}/${vencimento}`,
        method: 'get'
    })
}

export function alteracaoVencimentoDuam(data) {
    return request({
        url: `${prex}/altera_vencimento`,
        method: 'post',
        data
    })
}
